import api from './api'

import type { CalculatePayload, Calculate, BuySubscriptionPayload } from '@/models/billing'

class ProductsApiService {
  static getInstance(): ProductsApiService {
    return this.instance || (this.instance = new this())
  }

  private static instance: ProductsApiService

  private baseUrl = '/store/'

  private constructor() {
    // empty for linter
  }

  getAllProducts () {
    const url = `${this.baseUrl}`
    return api.get(url)
  }

  calculateSubscription(payload: CalculatePayload) {
    const {users, months, upgrade} = payload
    const url = `${this.baseUrl}subscription/calculate?users=${users}&months=${months}&upgrade=${upgrade}`
    return api.get<Calculate>(url)
  }

  buySubscription(payload: BuySubscriptionPayload) {
    const url = `${this.baseUrl}subscription/buy`
    return api.post<string>(url, payload)
  }
}

export default ProductsApiService.getInstance()
